<div class="modal-dialog">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">{{ 'Confirm removal' | t }}</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" [attr.aria-label]="'Close' | t"></button>
        </div>
        <div class="modal-body text-start">
            {{ 'Are you sure you want to remove “{item}”?' | t: {item: removeWhat} }}
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ 'Cancel' | t }}</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="confirm.emit()">{{ 'Confirm' | t }}</button>
        </div>
    </div>
</div>


